export class BoundBookList {
    bound_book_id: string | null = null;
    state: string | null = null;
    firearm_id: number | null = null;
    firearm: string | null = null;
    serial_number: string | null = null;
    received_from: string | null = null;
    transfered_to: string | null = null;
    date_acquired: string | null = null;
    date_disposed: string | null = null;
    select_item: boolean | undefined = false;
    form_4473_transfer_number: string | null = null;
    d_id: string | null = null;
    has_pending_3310: boolean = false;
    pending3310_id: string | null = null;
}
